import { useUnifiedAuth } from '@/contexts/UnifiedAuthContext';
import { useFaroUserTracking } from '@/hooks/useGrafanaFaro';

/**
 * Компонент для автоматического отслеживания user ID в Grafana Faro
 * Синхронизирует auth state из UnifiedAuthContext с Faro
 *
 * Размещается внутри провайдеров, но вне Routes
 *
 * @example
 * <FaroUserTracker />
 */
export const FaroUserTracker = () => {
  const { user } = useUnifiedAuth();
  useFaroUserTracking(user);

  return null;
};
